import styled, { css } from 'styled-components';

import media from '../../styles/media.style';
import { BLACK, WHITE, BORDER_GRAY, BG_GRAY, TEXT_GRAY } from '../../styles/variables.style';

export const Wrapper = styled.div`
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
`;

export const BlackOverlay = styled.div`
  background-color: ${BLACK};
  position: fixed;
  opacity: 0.5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 99;

  ${media.tabletP`
    display: block;
  `};
`;

const MixinContent = css`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const Content = styled.div`
  &.commonType {
    ${MixinContent};
    width: 100%;
    max-width: 728px;
    top: 45%;
  }

  &.sublimicDiagnosisConfirmType {
    ${MixinContent};
    width: 100%;
    top: 45%;

    ${media.tabletP`
      width: auto;
      max-width: 500px;
    `};
  }

  &.customerVisitExitType {
    ${MixinContent};
    width: calc(100% - 40px);
    top: 45%;

    ${media.tabletP`
      width: 612px;
    `};
  }

  &.customerVisitCameraType,
  &.customerVisitReloadType {
    ${MixinContent};
    width: calc(100% - 40px);
    top: 45%;

    ${media.tabletP`
      width: 460px;
    `};
  }

  &.salonSolutionType {
    ${MixinContent};
    width: calc(100% - 40px);
    top: 45%;

    ${media.tabletP`
      width: 612px;
    `};
  }

  &.installManualType {
    ${MixinContent};
    width: 100%;
    max-width: 728px;
    top: 45%;
  }

  &.customerRegisterType,
  &.signUpType {
    ${MixinContent};
    width: 100%;
    max-width: 728px;
    top: 45%;
  }
`;

const MixinBody = css`
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background-color: ${WHITE};
  box-shadow: 0px 10px 28.2px 1.8px rgba(0, 0, 0, 0.2);
`;
export const Body = styled.div`
  &.commonType {
    ${MixinBody};
    max-height: 75vh;
    padding: 0 80px;
  }

  &.sublimicDiagnosisConfirmType {
    ${MixinBody};
    width: auto;
    padding: 30px 20px;

    ${media.tabletP`
      width: 500px;
      padding: 50px;
    `};
  }

  &.customerVisitExitType {
    ${MixinBody};
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${WHITE};
    padding: 40px 25px;

    ${media.tabletP`
      padding: 70px 125px 55px 125px;
    `};
  }

  &.customerVisitCameraType {
    ${MixinBody};
    width: 100%;
    padding: 45px 28px;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    background-color: ${WHITE};

    ${media.tabletP`
      padding: 80px;
    `};
  }

  &.customerVisitReloadType {
    ${MixinBody};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 230px;
  }

  &.salonSolutionType {
    ${MixinBody};
    max-height: calc(100vh - 150px);
    padding: 20px;
    background-color: ${WHITE};

    ${media.tabletP`
      height: unset;
      max-height: 612px;
      padding: 0;
    `};
  }

  &.partnersNewVisitType {
    background-color: ${WHITE};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 25px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999999;

    ${media.tabletP`
      right: auto;
      bottom: auto;
      width: 80%;
      top: 175px;
      padding: 100px 130px;
      left: 50%;
      transform: translateX(-50%);
    `};
  }

  &.installManualType {
    ${MixinBody};
    max-height: 75vh;
    padding: 0 20px;

    ${media.tabletP`
      padding: 0 80px;
    `};
  }

  &.customerRegisterType,
  &.signUpType {
    ${MixinBody};
    max-height: 75vh;
    padding: 0 20px;

    ${media.tabletP`
      padding: 0 80px;
    `};
  }
`;

export const Header = styled.div`
  text-align: left;
  cursor: pointer;
  color: ${BLACK};
  font-size: 14px;
  padding: 16px 0;
  text-align: right;
  background-color: rgba(0, 0, 0, 0);
  > .closeButton {
    display: inline-block;
    &:after,
    &:before {
      position: absolute;
      top: 48%;
      left: -21px;
      transform: translateY(-50%) rotate(45deg);
      content: '';
      display: block;
      width: 20px;
      height: 1px;
      background: ${BLACK};
      ${media.tabletP`
        left: -16px;
        width: 15px;
      `};
    }

    &:after {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
`;

export const CloseButton = styled.div`
  &.commonType,
  &.customerVisitExitType,
  &.customerVisitCameraType,
  &.salonSolutionType,
  &.installManualType,
  &.sublimicDiagnosisConfirmType,
  &.partnersNewVisitType,
  &.customerRegisterType,
  &.signUpType {
    position: relative;
  }

  &.partnersNewVisitType {
    position: absolute;
    top: 30px;
    right: 20px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    padding: 0;
  }

  &.customerRegisterType,
  &.signUpType,
  &.installManualType {
    padding-right: 16px;
    ${media.tabletP`
      padding-right: unset;
    `};
  }
`;

export const CloseIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  right: 0;
  display: inline-block;
  width: 30px;
  height: 30px;
  color: ${BLACK};
  background-color: transparent;
  border-radius: 50%;
  vertical-align: middle;
  line-height: 40px;
  padding-left: 12px;

  ::after {
    content: '';
    width: 25px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transform: translate(-50%, -50%);
  }

  ::before {
    content: '';
    width: 25px;
    height: 2px;
    background-color: ${BLACK};
    position: absolute;
    top: 51%;
    left: 51%;
    transition: transform 0.3s;
    transform: translate(-50%, -50%) rotate(${({ open }) => (open ? 0 : '90deg')});
  }
`;

export const BodyDescriptionText = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${BLACK};
  text-align: center;
  padding-bottom: 30px;
`;

export const BodyHeading = styled.div`
  font-size: 22px;
  color: ${BLACK};
  margin: 40px 0;
  font-weight: bold;
  text-align: center;
`;

export const MarkdownComponentStyle = styled.div`
  color: ${BLACK};

  p {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.1px;
    margin: 12px 0 0;
  }
`;

export const MarkdownCommon = styled.div`
  color: ${BLACK};
  padding-bottom: 60px;

  h5 {
    margin-bottom: 20px;
  }

  p {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.1px;
    margin: 0;
    padding-bottom: 40px;
  }

  li {
    font-size: 14px;
  }
`;

export const MarkdownSalonSolution = styled.div`
  font-size: 14px;
  color: ${BLACK};
`;

export const CommonContainer = styled.div`
  margin: 0;

  &.salonSolutionType {
    width: 100%;
    height: 100%;
  }

  &.partnersNewVisitType {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &.customerVisitCameraType-ScalpCamera,
  &.customerVisitCameraType-DeviceCamera {
    width: calc(100% - 40px);
    ${media.tabletP`
      width: 100%;
    `};
  }

  &.customerVisitExitType {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% - 40px);
    ${media.tabletP`
      width: 100%;
    `};
  }
`;

export const MarkdownWrapper = styled.div`
  &.installManualType {
    display: flex;
    height: 100%;
  }

  &.salonSolutionType {
    width: 100%;
    height: auto;
    padding: 0;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${WHITE};

    ${media.tabletP`
      padding: 80px;
      flex-direction: row;
    `};
  }
`;

export const ImageWrapper = styled.div`
  &.installManualType {
    width: 100%;
    padding: 30px 0;
  }

  &.salonSolutionType {
    width: 100%;

    ${media.tabletP`
      width: 200px;
    `};
  }
`;

export const TextWrapper = styled.div`
  &.installManualType {
    width: 100%;
    padding: 30px 0 42px;
  }

  &.salonSolutionType {
    width: 100;
    flex: 1;
    padding: 3px 0 18px 0;

    ${media.tabletP`
      width: 100%;
      margin-left: 20px;
      padding: unset;
    `};
  }
`;

export const Image = styled.img`
  &.installManualType {
    width: calc(100% - 40px);
  }
`;

export const Hr = styled.div`
  width: 100%;
  height: 1px;
  background: ${BORDER_GRAY.HAIR_BEAUTY_PRO.MODAL};
  margin: 0;
`;

export const Date = styled.div`
  color: ${WHITE};
  text-align: right;
  margin: 0 30px 30px;
`;

export const Button = styled.button`
  &.sublimicDiagnosisConfirmType {
    display: block;
    margin: 0 auto;
    width: 100%;
    color: ${WHITE};
    background: ${BG_GRAY.COMMON_4};
    padding: 20px 10px;
    border: none;
    font-size: 16px;
    margin-bottom: 20px;

    ${media.tabletP`
      width: 300px;
      padding: 20px;
      margin-bottom: 50px;
    `};

    &:last-child {
      margin-bottom: 0;
    }
  }

  &.customerVisitReloadType {
    width: 300px;
    height: 65px;
    color: ${WHITE};
    background: ${BLACK};
  }

  &.partnersNewVisitType-Save {
    max-width: 300px;
    width: 100%;
    height: 65px;
    line-height: 65px;
    color: ${WHITE};
    background-color: ${BLACK};
    cursor: pointer;
    text-transform: uppercase;
    border: none;
    padding: 0;
    font-weight: 800;
    margin-bottom: 2em;
  }

  &.partnersNewVisitType-Cancel {
    background-color: transparent;
    border: none;
    padding: 0;
    text-decoration: underline;
    color: ${BLACK};
    cursor: pointer;
    font-weight: 800;
  }

  &.customerVisitCameraType-ScalpCamera,
  &.customerVisitCameraType-DeviceCamera {
    position: relative;
    width: 278px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    box-sizing: border-box;
    color: ${WHITE};
    border: none;
    background: ${BLACK};
    margin-bottom: 15px;
    ${media.tabletP`
      width: 300px;
      height: 65px;
      line-height: 65px;
      font-size: 16px;
  `};
  }

  &.customerVisitExitType {
    width: 278px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    box-sizing: border-box;
    color: ${WHITE};
    border: none;
    background: ${BLACK};
    position: relative;
    ${media.tabletP`
      font-size: 16px;
      width: 325px;
      height: 65px;
      line-height: 65px;
  `};
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 15px;
  height: 15px;

  ::after {
    content: ' ';
    display: block;
    width: 15px;
    height: 15px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid ${WHITE};
    border-color: ${WHITE} transparent ${WHITE} transparent;
    animation: spinner 1.2s linear infinite;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Text = styled.div`
  &.customerVisitExitType {
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: ${BLACK};
    margin-bottom: 25px;

    ${media.tabletP`
      font-size: 22px;
      margin-bottom: 40px;
    `};
  }

  &.customerVisitCameraType {
    width: 275px;
    font-size: 12px;
    font-weight: 500;
    text-align: left;
    color: ${TEXT_GRAY.COMMON_2};
    margin-bottom: 30px;

    ${media.tabletP`
      width: 350px;
      margin-bottom: 40px;
    `};

    &:last-child {
      margin-bottom: 0;
    }
  }

  &.partnersNewVisitType {
    font-size: 19px;
    text-align: center;
    margin-bottom: 1em;
  }

  &.salonSolutionType-Description {
    font-size: 14px;
    font-weight: 500;
    color: ${BLACK};
    padding-bottom: 20px;
  }

  &.salonSolutionType-Method {
    font-size: 14px;
    font-weight: 800;
    color: ${BLACK};
    margin-top: 20px;
    margin-bottom: 5px;
  }

  &.salonSolutionType-AmountOfUseTitle {
    font-size: 14px;
    font-weight: 800;
    color: ${BLACK};
    margin-top: 20px;
    margin-bottom: 5px;
  }

  &.salonSolutionType-AmountOfUseList {
    list-style: none;
  }

  &.salonSolutionType-ProductName {
    font-size: 18px;
    font-weight: 500;
    color: ${BLACK};
    margin-bottom: 15px;
    font-weight: bold;
  }

  &.customerRegisterType,
  &.signUpType {
    h1 {
      text-align: center;
      ${media.tabletP`
        text-align: unset;
      `};
    }
  }

  &.installManualType-NoteTitle {
    line-height: 24px;
    font-size: 22px;
    padding: 60px 0 30px;
    letter-spacing: 1px;
    color: ${BLACK};
    text-align: center;
  }

  &.installManualType-NoteContent {
    font-size: 14px;
    color: ${BLACK};
  }
`;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.style.js